var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { IconButton, AppBar, Box, Toolbar, Typography, } from "@material-ui/core";
import { Menu as MunuIcon } from "@material-ui/icons";
import { useLayoutConsumers } from "../provider";
import { UtcTime } from "./utcTime";
import { Profile } from "./profile";
import { useStyles } from "./styles";
import { useMemo } from "react";
export var Header = function (props) {
    var _a = useLayoutConsumers(), menuToggle = _a.menuToggle, menu = _a.menu, currentPath = _a.currentPath, showPageTitle = _a.showPageTitle, titleComponent = _a.titleComponent;
    var classes = useStyles();
    var pageTitle = useMemo(function () {
        var _a, _b, _c;
        var activePage = null;
        if (showPageTitle)
            mainLoop: for (var _i = 0, _d = menu.list; _i < _d.length; _i++) {
                var M = _d[_i];
                if ((_a = M.children) === null || _a === void 0 ? void 0 : _a.length) {
                    for (var _e = 0, _f = M.children; _e < _f.length; _e++) {
                        var C = _f[_e];
                        if (((_b = C.path) === null || _b === void 0 ? void 0 : _b.toLowerCase()) === currentPath.toLowerCase()) {
                            activePage = C.title;
                            break mainLoop;
                        }
                    }
                }
                else if (((_c = M.path) === null || _c === void 0 ? void 0 : _c.toLowerCase()) === currentPath.toLowerCase()) {
                    activePage = M.title;
                    break;
                }
            }
        return activePage;
    }, [currentPath, menu.list, showPageTitle]);
    return (_jsx(Box, __assign({ className: classes.root }, { children: _jsx(AppBar, __assign({ elevation: 1, className: classes.appBar }, { children: _jsxs(Toolbar, __assign({ variant: "dense", className: classes.toolbar }, { children: [_jsxs(Box, __assign({ display: "flex", flex: "1 1" }, { children: [_jsx(IconButton, __assign({ edge: "start", "aria-label": "menu", size: "small", className: classes.menuIcon, onClick: function () { return menuToggle(); } }, { children: _jsx(MunuIcon, {}) })), showPageTitle ? (_jsx(Typography, __assign({ className: classes.pageTitle }, { children: _jsx("b", { children: pageTitle }) }))) : null, titleComponent ? titleComponent : null] })), _jsxs(Box, __assign({ display: "flex", alignItems: "center" }, { children: [_jsx(UtcTime, {}), _jsx(Profile, __assign({}, props))] }))] })) })) })));
};
